import { useState } from "react";
import "./index.css";
import { NavLink } from "react-router-dom";

const HamburgerMenu = ({ isAuthenticated, openModal, logout, canManagePayments }) => {
  const [isOpen, setIsOpen] = useState(false);
  const closeMenu = () => setIsOpen(false);

  return (
    <div className="menu-mobile">
      <button
        type="button"
        className={`hamburger ${isOpen ? "open" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-label={isOpen ? "Close navigation menu" : "Open navigation menu"}
        aria-expanded={isOpen}
      >
        <span />
        <span />
        <span />
      </button>

      <nav className={`menu ${isOpen ? "show" : ""}`}>
        <div className="menu-panel-label">Navigation</div>
        <NavLink to="/" exact="true" onClick={closeMenu} className={({ isActive }) => isActive ? "nav-item nav-item-active" : "nav-item"}>
          Home
        </NavLink>
        {isAuthenticated && <NavLink to="/inventory" onClick={closeMenu} className={({ isActive }) => isActive ? "nav-item nav-item-active" : "nav-item"}>Inventory</NavLink>}
        {isAuthenticated && <NavLink to="/dispatch" onClick={closeMenu} className={({ isActive }) => isActive ? "nav-item nav-item-active" : "nav-item"}>Dispatch</NavLink>}
        {isAuthenticated && <NavLink to="/license" onClick={closeMenu} className={({ isActive }) => isActive ? "nav-item nav-item-active" : "nav-item"}>Licenses</NavLink>}
        <span
          onClick={() => {
            closeMenu();
            openModal();
          }}
          className="nav-item navLink nav-item-cta"
        >
          New Job
        </span>
        <NavLink to="/customers" onClick={closeMenu} className={({ isActive }) => isActive ? "nav-item nav-item-active" : "nav-item"}>Customer Types</NavLink>

        {isAuthenticated && <NavLink to="/staff" onClick={closeMenu} className={({ isActive }) => isActive ? "nav-item nav-item-active" : "nav-item"}>Staff Hours</NavLink>}

        {isAuthenticated && <NavLink to="/portal" onClick={closeMenu} className={({ isActive }) => isActive ? "nav-item nav-item-active" : "nav-item"}>Customer Portal</NavLink>}
        {canManagePayments && <NavLink to="/payment-settings" onClick={closeMenu} className={({ isActive }) => isActive ? "nav-item nav-item-active" : "nav-item"}>Credit Card Processing</NavLink>}

        {isAuthenticated && (
          <span onClick={() => {
            closeMenu();
            logout();
          }} className="nav-item navLink nav-item-logout">
            Logout
          </span>
        )}
      </nav>
    </div>
  );
};

export default HamburgerMenu;
